import { Directive, Input, HostListener, inject } from '@angular/core';
import { SnackbarOptions } from '@nx-customer-apps/shared/interfaces';
import { SnackbarService } from '@nx-customer-apps/shared/services';

@Directive({ selector: '[vpSnackbar]' })
export class SnackbarDirective {
    private snackbarService = inject(SnackbarService);

    @Input('vpSnackbar') message: string;

    @Input() vpSnackbarOptions: SnackbarOptions;

    @HostListener('click') onClick() {
        if (this.message) {
            this.snackbarService.showInfo(this.message, this.vpSnackbarOptions);
        }
    }
}
